import React, {useState, MouseEvent} from 'react';

import {curry} from 'ramda';
import wrap from 'wraptile';
import JiraMenu from './JiraMenu';

// @ts-ignore
import {ReactComponent as JiraIcon} from './assets/jira-icon.svg';
import {JiraIssue} from './JiraTypes';

interface JiraMenuContainerProps {
    issues: JiraIssue[];
    title?: string;
    priority: number;
    contentPartner: string;
    labPartner: string;
    id: number;
}

export default function JiraMenuContainer(props: JiraMenuContainerProps) {
    const {
        issues,
        title,
        priority,
        contentPartner,
        labPartner,
        id,
    } = props;
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [dialogIsOpen, setOpenDialog] = useState(false);
    const open = Boolean(anchorEl);
    const handleClick = handleJiraMenuPopupOpen(setAnchorEl);
    const handleDialogOpen = () => setOpenDialog(true);
    const handleDialogClose = () => setOpenDialog(false);
    
    return (
        <div>
            <JiraIcon
                className="jira-icon"
                onClick={handleClick}
            />
            <JiraMenu
                open={open}
                onClose={handleClose(setAnchorEl)}
                anchorEl={anchorEl}
                issues={issues}
                dialogIsOpen={dialogIsOpen}
                handleDialogOpen={handleDialogOpen}
                handleDialogClose={handleDialogClose}
                title={title}
                priority={priority}
                contentPartner={contentPartner}
                labPartner={labPartner}
                id={id}
            />
        </div>
    );
}

export const handleJiraMenuPopupOpen = curry((setAnchorEl: (el: HTMLButtonElement | null) => void, event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
});

export const handleClose = wrap((setAnchorEl: (el: HTMLButtonElement | null) => void) => setAnchorEl(null));

JiraMenuContainer.defaultProps = {
    title: '',
};
